export class StatusShiftingConstant {
    static STATUS_PENDING_ID = "PENDING";
    static STATUS_DONE_ID = "DONE";
  
    static SHIFTING_STATUS_OPTIONS = [
      { label: "En cours", value: this.STATUS_PENDING_ID },
      { label: "Terminé", value: this.STATUS_DONE_ID },
    ];
  }
  
  export const getShiftingStatusTagData = (id: string) => {
    const option = StatusShiftingConstant.SHIFTING_STATUS_OPTIONS.find(
      (opt) => opt.value === id
    );
    let color = "default";
    switch (id) {
      case StatusShiftingConstant.STATUS_PENDING_ID:
        color = "blue";
        break;
      case StatusShiftingConstant.STATUS_DONE_ID:
        color = "green";
        break;
    }
    return { label: option?.label || id, color };
  };
  